/**
 * This module contains mixins that encapsulate code so that it may be used by
 * multilpe components. Specifically, components have an "is-a" relationship with
 * mixins, which gives them access to a mixin's functionality through
 * inheritance. The mixins in this module are not intended for users of this
 * library.
 *
 * @module mixins
 */
export * from './lis-paginated-search-mixin';
